import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductionService {

  private url = environment.api + "api/erp/productions";
  constructor(
    private http: HttpClient,
  ) { }

  getReportProductions(startDate: any, endDate: any) {
    return this.http.get(this.url + `/report/${startDate}/${endDate}`)
  }
}
